<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-03-18 16:53:08
 * @LastEditors: 倪国晓
 * @LastEditTime: 2022-10-27 16:18:27
-->
<template>
	<el-dialog title="规则说明" :visible.sync="dialogVisible" width="560px" :before-close="handleClose">
		<!-- 抖音平台 -->
		<div class="yx-color-text-primary" v-if="$isDy()">
			<template v-if="flag === 1">
				<div>1、若同个达人仅允许1个{{ drName }}跟进，系统会校验关系的唯一性，达人被录入/认领后，其他{{ drName }}无法再录入/认领。</div>
				<div class="mt-24">
					2、{{ drName }}与达人跟进关系从多对1切换到1对1时，若存在多个{{ drName }}同时跟进某个达人，管理员需为其指定1位最终跟进人。
				</div>
			</template>
			<div v-if="flag === 2">
				{{
					drName
				}}对已认领达人的跟进行为符合所设任意规则即认领达人会展示"已到期"标识，认领已到期状态的达人可在团队公海被其他商务认领，无新商务认领情况下原商务可继续跟进，一旦达人被其他商务认领则原商务无法继续跟进。
			</div>
			<!-- 抖音平台下业绩归属文案 -->
			<div v-if="flag !== 1">
				<div class="font-bold">仅按参数链接判断归属</div>
				<div class="mt-12">1、根据专属商品链接所带参数来识别业绩归属；</div>
				<div class="mt-12">2、无参数时不自动识别业绩归属，需手动补单；</div>
				<div class="mt-24 font-bold">优先按商务唯一认领关系判断归属</div>
				<div class="mt-12">1、只有一个商务认领达人时，达人所有订单均将归属于所绑{{ drName }}；</div>
				<div class="mt-12">
					2、多商务认领同达人或无商务认领达人时，则根据专属商品链接所带参数来识别业绩归属，同时针对漏单(未识别归属的订单)可手动补充{{ drName }}信息；
				</div>
				<div class="mt-24 font-bold">按合作进度判断归属</div>
				<div class="mt-12">
					1、根据【合作进度】里记录的商品id+达人id来识别业绩归属，同时针对漏单或撞单(未识别归属的订单)可手动补充{{
						drName
					}}信息；达人实际带货的商品id与合作进度中记录的商品id若不一致，业绩将无法匹配，需要修改合作进度中的商品id；
				</div>
				<div class="mt-12">
					2、
					{{
						drName
					}}与达人跟进关系从多对1切换到1对1时，系统会将多人跟进的达人数据筛选出由您确定最终跟进人，业绩归属也按唯一跟进人匹配，已归属订单业绩不会改动；
				</div>
			</div>
		</div>
		<!-- 视频号 -->
		<div class="yx-color-text-primary" v-else-if="$isSp()">
			<template v-if="flag === 1">
				<div>1、若同个达人仅允许1个达人商务跟进，系统会校验关系的唯一性，达人被录入/认领后，其他达人商务无法再录入/认领。</div>
				<div class="mt-24">2、达人商务与达人跟进关系从多对1切换到1对1时，若存在多个达人商务同时跟进某个达人，管理员需为其指定1位最终跟进人。</div>
			</template>
			<template v-if="flag === 2">
				达人商务对已认领达人的跟进行为符合所设任意规则即认领达人会展示"已到期"标识，认领已到期状态的达人可在团队公海被其他商务认领，无新商务认领情况下原商务可继续跟进，一旦达人被其他商务认领则原商务无法继续跟进。
				<div class="font-bold mt-12">按达人跟进关系判断归属</div>
				<div class="mt-12">1、只有一个商务认领达人时，达人所有订单均将归属于所绑{{ drName }}；</div>
				<div class="mt-12">2、多商务认领同达人或无商务认领达人时，订单不自动归属可在订单管理手动修改订单归属；</div>
				<div class="font-bold mt-24">按合作进度判断归属</div>
				<div class="mt-12">
					1、根据【合作进度】里记录的商品id+达人id来识别业绩归属，同时针对漏单或撞单(未识别归属的订单)可手动补充达人商务信息；达人实际带货的商品id与合作进度中记录的商品id若不一致，业绩将无法匹配，需要修改合作进度中的商品id；
				</div>
				<div class="mt-12">
					2、
					达人商务与达人跟进关系从多对1切换到1对1时，系统会将多人跟进的达人数据筛选出由您确定最终跟进人，业绩归属也按唯一跟进人匹配，已归属订单业绩不会改动；
				</div>
			</template>
			<template v-if="flag === 3">
				<div class="font-bold mt-12">按达人跟进关系判断归属</div>
				<div class="mt-12">1、只有一个商务认领达人时，达人所有订单均将归属于所绑{{ drName }}；</div>
				<div class="mt-12">2、多商务认领同达人或无商务认领达人时，订单不自动归属可在订单管理手动修改订单归属；</div>
				<div class="mt-24 font-bold">按合作进度判断归属</div>
				<div class="mt-12">
					1、根据【合作进度】里记录的商品id+达人id来识别业绩归属，同时针对漏单或撞单(未识别归属的订单)可手动补充{{
						drName
					}}信息；达人实际带货的商品id与合作进度中记录的商品id若不一致，业绩将无法匹配，需要修改合作进度中的商品id；
				</div>
				<div class="mt-12">
					2、
					{{
						drName
					}}与达人跟进关系从多对1切换到1对1时，系统会将多人跟进的达人数据筛选出由您确定最终跟进人，业绩归属也按唯一跟进人匹配，已归属订单业绩不会改动；
				</div>
			</template>
		</div>
		<!-- 快手平台 -->
		<div class="yx-color-text-primary" v-else-if="$isKs()">
			<template v-if="flag === 1">
				<div>
					1、若同个达人仅允许1个{{ drName }}跟进，达人带货订单均归属为{{ drName }}业绩(从授权系统时间开始的订单才会归属，授权前产生的订单不归属)；
				</div>
				<div class="mt-24">
					2、若多{{ drName }}允许跟进同1个达人，则根据合作进度里记录的商品id来识别业绩归属，同时针对漏单或撞单(未识别归属的订单)可手动补充{{
						drName
					}}信息；达人实际带货的商品id与合作进度中记录的商品id若不一致，业绩将无法匹配，需要修改合作进度中的商品id。
				</div>
				<div class="mt-24">
					3、{{
						drName
					}}与达人跟进关系从多对1切换到1对1时，系统会将多人跟进的达人数据筛选出由您确定最终跟进人，业绩归属也按唯一跟进人匹配，已归属订单业绩不会改动。
				</div>
			</template>
			<template v-if="flag === 2">
				{{
					drName
				}}对已认领达人的跟进行为符合所设任意规则即认领达人会展示"已到期"标识，认领已到期状态的达人可在团队公海被其他商务认领，无新商务认领情况下原商务可继续跟进，一旦达人被其他商务认领则原商务无法继续跟进。
			</template>
			<template>
				<div class="font-bold">按达人跟进关系判断归属</div>
				<div class="mt-12">1、只有一个商务认领达人时，达人所有订单均将归属于所绑{{ drName }}；</div>
				<div class="mt-12">2、多商务认领同达人或无商务认领达人时，订单不自动归属可在订单管理手动修改订单归属；</div>
				<div class="mt-24 font-bold">按合作进度判断归属</div>
				<div class="mt-12">
					1、 根据【合作进度】里记录的商品id+达人id来识别业绩归属，同时针对漏单或撞单(未识别归属的订单)可手动补充{{
						drName
					}}信息；达人实际带货的商品id与合作进度中记录的商品id若不一致，业绩将无法匹配，需要修改合作进度中的商品id；
				</div>
				<div class="mt-12">
					2、
					{{
						drName
					}}与达人跟进关系从多对1切换到1对1时，系统会将多人跟进的达人数据筛选出由您确定最终跟进人，业绩归属也按唯一跟进人匹配，已归属订单业绩不会改动；
				</div>
			</template>
		</div>
		<span slot="footer">
			<el-button type="primary" @click="handleClose">我知道了</el-button>
		</span>
	</el-dialog>
</template>

<script>
import { PLATFORM_KS, drRoleType } from '@/utils/dataMap';
export default {
	name: 'ruleExplainDialog',
	data() {
		return {
			flag: 1,
			dialogVisible: false,
			platformId: '',
		};
	},
	computed: {
		isKsPlatform() {
			const { platformId } = this;
			return +platformId === +PLATFORM_KS.value;
		},
		drName() {
			return drRoleType.name;
		},
	},
	methods: {
		show(flag, platformId) {
			this.platformId = platformId;
			this.flag = flag;
			this.dialogVisible = true;
		},
		handleClose() {
			this.dialogVisible = false;
		},
	},
};
</script>

<style lang="less" scoped></style>
